export default __webpack_public_path__ + "static/media/1.eaaad0c4.png";